import EventAdaptingStateHandler from "src/states/EventAdaptingStateHandler"
import StateConstants from "src/states/StateContstants"
import PathRouter from "src/navigation/PathRouter"


export default class ParamParser {
    stateHandler: EventAdaptingStateHandler

    constructor(stateHandler: EventAdaptingStateHandler) {
        this.stateHandler = stateHandler
    }

    parseAddress(params: any) {
        let address = "";
        if (PathRouter.ADDRESS_PARAM in params) {
            address = params[PathRouter.ADDRESS_PARAM]
        }
        return address
    }

    parseHouseCondition(params: any) {
        let houseCondition = this.stateHandler.get(StateConstants.RELATIVE_CONDITION)
        console.log("houseCondition initial", houseCondition)
        if (PathRouter.HOUSE_CONDITION_PARAM in params) {
            let parsedValue = parseFloat(params[PathRouter.HOUSE_CONDITION_PARAM])
            if (!isNaN(parsedValue)) {
                parsedValue = Math.min(Math.max(parsedValue, 0), 1)
                houseCondition = parsedValue
            }
        }
        return houseCondition
    }

    parseRemovedHomes(params: any) {
        let removedHomes = this.stateHandler.get(StateConstants.REMOVED_HOMES)
        if (PathRouter.REMOVED_HOMES_PARAM in params) {
            removedHomes = params[PathRouter.REMOVED_HOMES_PARAM].split(",")
        }
        return removedHomes
    }
}
